import { render } from "./DeviceCreate.vue?vue&type=template&id=508ef12a&scoped=true"
import script from "./DeviceCreate.vue?vue&type=script&lang=js"
export * from "./DeviceCreate.vue?vue&type=script&lang=js"

import "./DeviceCreate.vue?vue&type=style&index=0&id=508ef12a&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508ef12a"]])

export default __exports__